import React from 'react';
import AppRouter from '@routes/AppRouter';
import { AuthProvider } from '@contexts/AuthContext';
import { OrganizationProvider } from '@contexts/OrganizationContext';
import { ThemeProvider } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import theme from '@themes/theme';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <OrganizationProvider>
        <ThemeProvider theme={theme}>
          <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <AppRouter />
        </ThemeProvider>
      </OrganizationProvider>
    </AuthProvider>
  );
};

export default App;
